/**
 * BLOCK: How-to Child - Attributes
 */

const attributes = {
	howtoChildTitle: {
		source: 'html',
		selector: 'h1,h2,h3,h4,h5,h6',
		default: 'Enter a step title',
	},
	headingDesc: {
		source: 'html',
		selector: 'p',
		default:
			'Click here to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
	},
	headingAlign: {
		type: 'string',
		default: 'left',
	},
	headingColor: {
		type: 'string',
	},
	subHeadingColor: {
		type: 'string',
	},
	iconimgPosition: {
		type: 'string',
		default: 'above-title',
	},
	headingTag: {
		type: 'string',
		default: 'h4',
	},
	headFontSize: {
		type: 'number',
	},
	headFontSizeType: {
		type: 'string',
		default: 'px',
	},
	headFontSizeTablet: {
		type: 'number',
	},
	headFontSizeMobile: {
		type: 'number',
	},
	headFontFamily: {
		type: 'string',
		default: 'Default',
	},
	headFontWeight: {
		type: 'string',
	},
	headFontSubset: {
		type: 'string',
	},
	headLineHeightType: {
		type: 'string',
		default: 'em',
	},
	headLineHeight: {
		type: 'number',
	},
	headLineHeightTablet: {
		type: 'number',
	},
	headLineHeightMobile: {
		type: 'number',
	},
	headLoadGoogleFonts: {
		type: 'boolean',
		default: false,
	},
	subHeadFontSize: {
		type: 'number',
	},
	subHeadFontSizeType: {
		type: 'string',
		default: 'px',
	},
	subHeadFontSizeTablet: {
		type: 'number',
	},
	subHeadFontSizeMobile: {
		type: 'number',
	},
	subHeadFontFamily: {
		type: 'string',
		default: 'Default',
	},
	subHeadFontWeight: {
		type: 'string',
	},
	subHeadFontSubset: {
		type: 'string',
	},
	subHeadLineHeightType: {
		type: 'string',
		default: 'em',
	},
	subHeadLineHeight: {
		type: 'number',
	},
	subHeadLineHeightTablet: {
		type: 'number',
	},
	subHeadLineHeightMobile: {
		type: 'number',
	},
	subHeadLoadGoogleFonts: {
		type: 'boolean',
		default: false,
	},
	headSpace: {
		type: 'number',
		default: 10,
	},
	subHeadSpace: {
		type: 'number',
		default: 10,
	},
	seperatorSpace: {
		type: 'number',
		default: 10,
	},
	iconimgBorderRadius: {
		type: 'number',
		default: 0,
	},
	sourceType: {
		type: 'string',
		default: 'image',
	},
	block_id: {
		type: 'string',
		default: 'not_set',
	},
	ctaTarget: {
		type: 'boolean',
		default: false,
	},
	ctaIcon: {
		type: 'string',
		default: '',
	},
	ctaIconPosition: {
		type: 'string',
		default: 'after',
	},
	ctaIconSpace: {
		type: 'number',
		default: 5,
	},
	seperatorPosition: {
		type: 'string',
		default: 'after_title',
	},
	seperatorStyle: {
		type: 'string',
		default: 'none',
	},
	seperatorColor: {
		type: 'string',
		default: '#333',
	},
	seperatorWidth: {
		type: 'number',
		default: 30,
	},
	separatorWidthType: {
		type: 'string',
		default: '%',
	},
	seperatorThickness: {
		type: 'number',
		default: 2,
	},
	ctaType: {
		type: 'string',
		default: 'all',
	},
	ctaText: {
		type: 'string',
		default: 'Read More',
	},
	ctaLink: {
		type: 'string',
		default: '#',
	},
	ctaLinkColor: {
		type: 'string',
		default: '#333',
	},
	ctaFontSize: {
		type: 'number',
	},
	ctaFontSizeType: {
		type: 'string',
		default: 'px',
	},
	ctaFontSizeMobile: {
		type: 'number',
	},
	ctaFontSizeTablet: {
		type: 'number',
	},
	ctaFontFamily: {
		type: 'string',
		default: 'Default',
	},
	ctaFontWeight: {
		type: 'string',
	},
	ctaFontSubset: {
		type: 'string',
	},
	ctaLoadGoogleFonts: {
		type: 'boolean',
		default: false,
	},
	ctaBtnLinkColor: {
		type: 'string',
		default: '#333',
	},
	ctaLinkHoverColor: {
		type: 'string',
		default: '',
	},
	ctaBgColor: {
		type: 'string',
		default: 'transparent',
	},
	ctaBgHoverColor: {
		type: 'string',
		default: 'transparent',
	},
	ctaBorderColor: {
		type: 'string',
		default: '#333',
	},
	ctaBorderhoverColor: {
		type: 'string',
		default: '',
	},
	ctaBorderStyle: {
		type: 'string',
		default: 'solid',
	},
	ctaBtnVertPadding: {
		type: 'number',
		default: 10,
	},
	ctaBtnHrPadding: {
		type: 'number',
		default: 14,
	},
	ctaBorderWidth: {
		type: 'number',
		default: 1,
	},
	ctaBorderRadius: {
		type: 'number',
		default: 0,
	},
	iconLeftMargin: {
		type: 'number',
		default: 0,
	},
	iconRightMargin: {
		type: 'number',
		default: 0,
	},
	iconTopMargin: {
		type: 'number',
		default: 10,
	},
	iconBottomMargin: {
		type: 'number',
		default: 10,
	},
	iconImage: {
		type: 'object',
		default: {
			url: '',
			alt: 'StepBox placeholder img',
		},
	},
	imageSize: {
		type: 'string',
		default: 'thumbnail',
	},
	imageWidth: {
		type: 'number',
		default: 120,
	},
	imageWidthType: {
		type: 'boolean',
		default: false,
	},
	showTitle: {
		type: 'boolean',
		default: true,
	},
	showDesc: {
		type: 'boolean',
		default: true,
	},
};

export default attributes;
